/**
 * Created by Carsten Bühler
 * User: CBuehler on 27.01.2016
 * Copyright: xdot GmbH 2015
 */
import React from 'external/react';
import PropTypes from "prop-types";

import { AppContext } from 'plugin/liferay-widgets-react-web';

import { getNamedPropStore } from '../stores/StoreFactory';

let NamedPropStore = getNamedPropStore(AppContext);

const NamedProp = ({ type, typeKey }) => {
    const prop = NamedPropStore.getPropByTypeKey(type, typeKey);
    if (!prop) {
        console.warn('Prop not found', type, typeKey);
    }
    return (
        <React.Fragment>{prop && prop.title ? prop.title : '---'}</React.Fragment>
    );
};

NamedProp.propTypes = {
    type: PropTypes.string,
    typeKey: PropTypes.string
};

export default NamedProp;



// WEBPACK FOOTER //
// ./js/components/NamedProp.jsx